import { render, staticRenderFns } from "./MainLogo.vue?vue&type=template&id=04d3d47e&functional=true&"
import script from "./MainLogo.vue?vue&type=script&lang=js&"
export * from "./MainLogo.vue?vue&type=script&lang=js&"
import style0 from "./MainLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./MainLogo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports